$(document).ready(function() {
	$(".contact-us").on("click", function() {
		$(this).colorbox({
			href:'#form-contact-us',
	        width:'700px',
	        height:'auto',
	        inline:true,
	        opacity: 0.3
		})
	});
})
